import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, OnChanges } from '@angular/core';
import MetisMenu from 'metismenujs';

import { Router, NavigationEnd } from '@angular/router';

import { HttpClient } from '@angular/common/http';

import {MENU } from './menu';
import { MenuItem } from './menu.model';
import { ApiserviceService } from 'src/app/core/services/apiservice.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('componentRef') scrollRef: { SimpleBar: { getScrollElement: () => { (): any; new(): any; scrollTop: number; }; } | null; } | undefined;
  @Input() isCondensed = false;
  menu: any;
  data: any;
  userkontrol:any;
  kurumkontrol:any;
  kurummenu=[];
  menuItems: MenuItem[] = [];



  @ViewChild('sideMenu') sideMenu: ElementRef | undefined;

  constructor( private router: Router, private http: HttpClient,public api:ApiserviceService) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
        this._scrollElement();
      }
    });
  }

  ngOnInit() {
    this.initialize();
    this._scrollElement();
   
  }

  ngAfterViewInit() {
    if (this.sideMenu) {
      this.menu = new MetisMenu(this.sideMenu.nativeElement);
      this._activateMenuDropdown();
    }
  }

  toggleMenu(event: { currentTarget: { nextElementSibling: { classList: { toggle: (arg0: string) => void; }; }; }; }) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  ngOnChanges() {
    if ((!this.isCondensed && this.sideMenu) || this.isCondensed) {
      setTimeout(() => {
        if (this.sideMenu) {
          this.menu = new MetisMenu(this.sideMenu.nativeElement);
        }
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }
  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName("mm-active").length > 0) {
        const activeElement = document.getElementsByClassName("mm-active")[0] as HTMLElement;
        const currentPosition = activeElement.offsetTop;
        if (currentPosition > 500) {
          if (this.scrollRef?.SimpleBar) {
            this.scrollRef.SimpleBar.getScrollElement().scrollTop =
              currentPosition + 300;
          }
        }
      }
    }, 300);
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className: string) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
/**
 * Activate the parent dropdown (Hash uyumlu versiyon)
 */
_activateMenuDropdown() {
  this._removeAllClass('mm-active');
  this._removeAllClass('mm-show');

  const links = document.getElementsByClassName('side-nav-link-ref');
  let menuItemEl: any = null;

  // Şu anki URL'yi bul
  // Eğer hash varsa: #/dashboard → /dashboard
  // Yoksa router.url kullan
  const currentUrl = window.location.hash
    ? window.location.hash.replace('#', '')
    : this.router.url;

  // Tüm link pathlerini topla
  const paths: string[] = [];
  for (let i = 0; i < links.length; i++) {
    const element = links[i] as HTMLAnchorElement;
    paths.push(element.pathname);
  }

  // Mevcut URL path'i listede ara
  let itemIndex = paths.indexOf(currentUrl);

  if (itemIndex === -1) {
    const strIndex = currentUrl.lastIndexOf('/');
    const item = currentUrl.substr(0, strIndex).toString();
    itemIndex = paths.indexOf(item);
  }

  if (itemIndex > -1) {
    menuItemEl = links[itemIndex];
  }

  if (menuItemEl) {
    menuItemEl.classList.add('active');
    const parentEl = menuItemEl.parentElement;

    if (parentEl) {
      parentEl.classList.add('mm-active');
      const parent2El = parentEl.parentElement.closest('ul');
      if (parent2El && parent2El.id !== 'side-menu') {
        parent2El.classList.add('mm-show');
        const parent3El = parent2El.parentElement;
        if (parent3El && parent3El.id !== 'side-menu') {
          parent3El.classList.add('mm-active');
          const childAnchor = parent3El.querySelector('.has-arrow');
          const childDropdown = parent3El.querySelector('.has-dropdown');
          if (childAnchor) { childAnchor.classList.add('mm-active'); }
          if (childDropdown) { childDropdown.classList.add('mm-active'); }
          const parent4El = parent3El.parentElement;
          if (parent4El && parent4El.id !== 'side-menu') {
            parent4El.classList.add('mm-show');
            const parent5El = parent4El.parentElement;
            if (parent5El && parent5El.id !== 'side-menu') {
              parent5El.classList.add('mm-active');
              const childanchor = parent5El.querySelector('.is-parent');
              if (childanchor && parent5El.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
            }
          }
        }
      }
    }
  }
}


  /**
   * Initialize
   */
  initialize(): void {
 
    this.menuItems = MENU
    
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

 




}
